import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import Back from '../../../shared/assets/images/svg/back_blue.svg'
import Tab from '../component/tabs/tab'
import EditProfile from '../../../shared/assets/images/svg/edite_profile_blue.svg';
import Assignment from '../../../shared/assets/images/svg/assignment_dark.svg';
import FileDark from '../../../shared/assets/images/svg/file_dark.svg';

const MyContract = () => {
    return (
        <div className='settingHome myContract'>
            <div className='container'>
                <div className="header">
                    <div className="page-name">
                        <Link className='linkBack' to="/settings">
                            <img src={Back} alt="back" />
                        </Link>
                        <h1>My Contract</h1>
                    </div>
                </div>
                <hr className='hr' />
                <div className="tabs">
                    <div className="nav">
                        <Tab url="/myContract" img={EditProfile} title="Assigned Representative" end/>
                        <Tab url="./contractInfo" img={Assignment} title="Contract Info" />
                        <Tab url="./contractFile" img={FileDark} title="Contract File" />
                    </div>
                </div>
                <Outlet />
            </div>
        </div>
    )
}

export default MyContract